import type { EditorGroup } from '../types/quote';

// EXAMPLE data — static placeholder values shown in the Loan Officer Editor.

export const editorGroups: EditorGroup[] = [
  {
    id: 'property',
    title: 'Property & down payment',
    fields: [
      { id: 'purchasePrice', label: 'Purchase price', source: 'lo', value: '$450,000' },
      { id: 'downPercent', label: 'Down payment %', source: 'lo', value: '10%' },
      { id: 'downAmount', label: 'Down payment $', source: 'auto', value: '$45,000' },
      { id: 'loanAmount', label: 'Loan amount', source: 'auto', value: '$405,000' },
    ],
  },
  {
    id: 'rate',
    title: 'Program & rate',
    fields: [
      {
        id: 'program',
        label: 'Loan program',
        source: 'lo',
        value: 'Full Doc',
        scenarioValues: { fullDoc: 'Full Doc', bankStatement: 'Bank Statement' },
      },
      {
        id: 'rate',
        label: 'Interest rate',
        source: 'lo',
        value: '6.500%',
        scenarioValues: { fullDoc: '6.500%', bankStatement: '7.375%' },
      },
      {
        id: 'apr',
        label: 'APR',
        source: 'lo',
        value: '6.710%',
        scenarioValues: { fullDoc: '6.710%', bankStatement: '7.612%' },
      },
    ],
  },
  {
    id: 'monthly',
    title: 'Monthly costs',
    fields: [
      {
        id: 'pi',
        label: 'Principal & interest',
        source: 'auto',
        value: '$2,559.88',
        scenarioValues: { fullDoc: '$2,559.88', bankStatement: '$2,797.24' },
      },
      { id: 'taxes', label: 'Property taxes / mo', source: 'lo', value: '$468.75' },
      { id: 'insurance', label: "Homeowner's insurance / mo", source: 'lo', value: '$145.00' },
      {
        id: 'mi',
        label: 'Mortgage insurance / mo',
        source: 'lo',
        value: '$168.75',
        scenarioValues: { fullDoc: '$168.75', bankStatement: '$202.50' },
      },
    ],
  },
  {
    id: 'closing',
    title: 'Fees & concessions',
    fields: [
      {
        id: 'origination',
        label: 'Origination fee',
        source: 'lo',
        value: '$4,050',
        scenarioValues: { fullDoc: '$4,050', bankStatement: '$6,075' },
      },
      {
        id: 'underwriting',
        label: 'Underwriting & funding',
        source: 'lo',
        value: '$1,295',
        scenarioValues: { fullDoc: '$1,295', bankStatement: '$1,495' },
      },
      { id: 'title', label: 'Title fees', source: 'lo', value: '$2,850' },
      { id: 'hoiPrepaid', label: 'Insurance prepaid', source: 'lo', value: '$1,740' },
      { id: 'concessions', label: 'Seller concessions', source: 'lo', value: '−$6,000' },
    ],
  },
  {
    id: 'contact',
    title: 'Loan officer contact',
    fields: [
      { id: 'loName', label: 'Name', source: 'lo', value: 'Jordan Avery' },
      { id: 'loNmls', label: 'NMLS #', source: 'lo', value: '000000' },
      { id: 'loPhone', label: 'Phone', source: 'lo', value: '(555) 010-0199' },
      { id: 'loEmail', label: 'Email', source: 'lo', value: 'jordan.avery@example.com' },
    ],
  },
];
